<section class="page" [class.mobile-page]="isMobileBrowser()" data-testid="appointments-visit-type-page">
  <app-page-header
    title="Reason for Visit"
    subtitle="This helps us route your request to the right team."
    [hideBack]="isModal"
    (back)="onCancel()"></app-page-header>

  <div class="page-content">
    <ng-container *ngrxLet="{ provider: patientCareTeamMember$ } as vm">
      @if (vm.provider === null) {
        <app-progress-spinner data-testid="appointments-visit-type-spinner"></app-progress-spinner>
      } @else {
        <div class="list" data-testid="appointments-visit-type-list">
          <div class="intro">
            <p>If this is urgent, <b>call 911</b> or visit your closest emergency room.</p>
          </div>
          <div class="option-grid" role="radiogroup" aria-label="Reason for visit">
            @for (visitType of visitTypes; track visitType.id; let idx = $index) {
              <div
                class="option-card"
                [style.--accent]="getVisitTypeAccent(visitType)"
                [class.is-selected]="selectedVisitTypeId() === visitType.id"
                [attr.data-testid]="'schedule-option-' + idx"
                role="radio"
                [attr.aria-checked]="selectedVisitTypeId() === visitType.id"
                tabindex="0"
                (click)="onVisitTypeActivate(visitType, vm.provider)"
                (keydown)="onRowKeydown($event, visitType, vm.provider)">
                <span class="left" aria-hidden="true">
                  <span class="icon-bubble">
                    <app-icon [name]="$any(getVisitTypeIcon(visitType))" size="md" color="on-surface"></app-icon>
                  </span>
                </span>

                <span class="meta">
                  <span class="name">{{ visitType.description }}</span>
                  <span class="sub">{{ visitType.isLocationSpecific ? 'In-person visit' : 'Virtual visit' }}</span>
                </span>

                <span class="right" aria-hidden="true">
                  @if (isMobileBrowser()) {
                    @if (selectedVisitTypeId() === visitType.id) {
                      <span class="check">
                        <app-icon name="check" size="sm" color="on-primary"></app-icon>
                      </span>
                    } @else {
                      <span class="radio"></span>
                    }
                  } @else {
                    <app-icon name="chevron_right" size="sm" color="on-surface-variant"></app-icon>
                  }
                </span>
              </div>
            }
          </div>
        </div>
      }
    </ng-container>
  </div>

  @if (!isModal) {
    <footer class="page-footer">
      <button
        mat-stroked-button
        type="button"
        class="error-btn"
        data-testid="appointments-step-cancel"
        (click)="onCancel()">
        Cancel
      </button>
      <button
        type="button"
        mat-flat-button
        class="primary-btn"
        data-testid="appointments-step-continue"
        [disabled]="!selectedVisitTypeId()"
        (click)="onContinue()">
        Continue
      </button>
    </footer>
  }
</section>
